import _ from "lodash";

export const getValue = (object, path, defaultValue) => {
  return _.defaultTo(_.get(object, `${path}`, defaultValue), defaultValue);
}